export enum LayoutBlockDisplayRatiosEnum {
    ONE_TO_ONE = 'ONE_TO_ONE',
    THREE_TO_SEVEN = 'THREE_TO_SEVEN',
    SEVEN_TO_THREE = 'SEVEN_TO_THREE',
    TWO_TO_EIGHT = 'TWO_TO_EIGHT',
    EIGHT_TO_TWO = 'EIGHT_TO_TWO',
    ONE_TO_ONE_TO_ONE = 'ONE_TO_ONE_TO_ONE',
    TWO_TO_SIX_TO_TWO = 'TWO_TO_SIX_TO_TWO',
    TWO_TO_TWO_TO_SIX = 'TWO_TO_TWO_TO_SIX',
    SIX_TO_TWO_TO_TWO = 'SIX_TO_TWO_TO_TWO'
};

export const layoutBlockDisplayRatiosToWidthPercentMap: Map<LayoutBlockDisplayRatiosEnum, string[]> = new Map([
    [LayoutBlockDisplayRatiosEnum.ONE_TO_ONE, ['50%', '50%']],
    [LayoutBlockDisplayRatiosEnum.THREE_TO_SEVEN, ['30%', '70%']],
    [LayoutBlockDisplayRatiosEnum.SEVEN_TO_THREE, ['70%', '30%']],
    [LayoutBlockDisplayRatiosEnum.TWO_TO_EIGHT, ['20%', '80%']],
    [LayoutBlockDisplayRatiosEnum.EIGHT_TO_TWO, ['80%', '20%']],
    [LayoutBlockDisplayRatiosEnum.ONE_TO_ONE_TO_ONE, ['33.33%', '33.33%', '33.33%']],
    [LayoutBlockDisplayRatiosEnum.TWO_TO_SIX_TO_TWO, ['20%', '60%', '20%']],
    [LayoutBlockDisplayRatiosEnum.TWO_TO_TWO_TO_SIX, ['20%', '20%', '60%']],
    [LayoutBlockDisplayRatiosEnum.SIX_TO_TWO_TO_TWO, ['60%', '20%', '20%']]
]);
